import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full overflow-y-auto max-w-14xl relative flex flex-col pt-4 mx-auto" }
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = { class: "overflow-x-auto flex flex-grow border border-gray-300 rounded-md" }
const _hoisted_4 = { class: "sticky left-0 z-20 pr-1 flex-initial flex-shrink-0 flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-0 flex-shrink-0 h-8 flex justify-center items-center py-0 px-1" }, null, -1)
const _hoisted_6 = { class: "absolute top-0 text-gray-400 font-normal text-xs" }
const _hoisted_7 = {
  class: "flex-grow-1 max-w-sm my-0 mx-3 flex-auto flex-shrink-0 hidden md:block",
  style: {"height":"928px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timetable_detail_dialog_content = _resolveComponent("timetable-detail-dialog-content")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_timetable_conflict_dialog_content = _resolveComponent("timetable-conflict-dialog-content")!
  const _component_timetable_search_bar = _resolveComponent("timetable-search-bar")!
  const _component_timetable_selected_course_list = _resolveComponent("timetable-selected-course-list")!
  const _component_timetable_head_bar = _resolveComponent("timetable-head-bar")!
  const _component_timetable_day = _resolveComponent("timetable-day")!
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_badge = _resolveComponent("f-badge")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_drawer, {
      height: "90%",
      placement: "bottom",
      closable: false,
      visible: _ctx.isDetailDialogVisible,
      onClose: _ctx.hideDetailDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_timetable_detail_dialog_content, {
          onDeleteCourse: _cache[0] || (_cache[0] = (id) => _ctx.removeSelectedCourse(id))
        })
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_a_drawer, {
      height: "90%",
      placement: "bottom",
      closable: false,
      visible: _ctx.isConflictDialogVisible,
      "mask-closable": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_timetable_conflict_dialog_content, {
          "selected-courses-ids": _ctx.selectedCoursesIds,
          "selected-courses-ids-from-database": _ctx.selectedCoursesIdsFromDatabase,
          courses: _ctx.allCourses,
          onConflictResolved: _ctx.onConflictResolved
        }, null, 8, ["selected-courses-ids", "selected-courses-ids-from-database", "courses", "onConflictResolved"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      height: "90%",
      placement: "bottom",
      closable: false,
      visible: _ctx.isSearchDialogVisible,
      class: "md:hidden",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSearchDialogVisible = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_timetable_search_bar, {
          "search-index": _ctx.searchIndex,
          "is-loading-courses": _ctx.isLoadingCourses,
          onAddCourse: _ctx.addSelectedCourse,
          onHideSearchDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSearchDialogVisible = false))
        }, null, 8, ["search-index", "is-loading-courses", "onAddCourse"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      height: "90%",
      placement: "right",
      closable: false,
      visible: _ctx.isSelectedCourseListVisible,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSelectedCourseListVisible = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_timetable_selected_course_list, {
          courses: _ctx.selectedCourses,
          onClickCloud: _ctx.fetchSelectedCourses,
          onClickBack: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSelectedCourseListVisible = false)),
          onDeleteCourse: _cache[4] || (_cache[4] = (courseId) => _ctx.removeSelectedCourse(courseId)),
          onShowDetail: _ctx.handleShowDetail
        }, null, 8, ["courses", "onClickCloud", "onShowDetail"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_timetable_head_bar, {
      semester: _ctx.semesterName,
      "hide-left": _ctx.semesterIndex === 0,
      "hide-right": _ctx.semesterIndex === _ctx.semesterArray.length - 1,
      onClickMenuButton: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSelectedCourseListVisible = true)),
      onClickLeft: _cache[7] || (_cache[7] = ($event: any) => (_ctx.moveSemester(-1))),
      onClickRight: _cache[8] || (_cache[8] = ($event: any) => (_ctx.moveSemester(1)))
    }, null, 8, ["semester", "hide-left", "hide-right"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { name: '1', clock: '08:00' },
              { name: '2', clock: '08:55' },
              { name: '3', clock: '09:55' },
              { name: '4', clock: '10:50' },
              { name: '5', clock: '11:45' },
              { name: '6', clock: '13:30' },
              { name: '7', clock: '14:25' },
              { name: '8', clock: '15:25' },
              { name: '9', clock: '16:20' },
              { name: '10', clock: '17:15' },
              { name: '11', clock: '18:30' },
              { name: '12', clock: '19:25' },
              { name: '13', clock: '20:20' },
              { name: '14', clock: '21:15' },
            ], (section, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "relative flex-grow-0 flex-shrink-0 h-16 flex justify-center items-center w-8 py-0 px-4 bg-white bg-opacity-50 text-gray-500 font-semibold"
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(section.clock), 1),
              _createTextVNode(" " + _toDisplayString(section.name), 1)
            ])
          }), 64))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSectionsByDay, (sectionsByDay, index) => {
          return (_openBlock(), _createBlock(_component_timetable_day, {
            key: index,
            title: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][index],
            sections: sectionsByDay
          }, null, 8, ["title", "sections"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_timetable_search_bar, {
          "search-index": _ctx.searchIndex,
          "is-loading-courses": _ctx.isLoadingCourses,
          onAddCourse: _ctx.addSelectedCourse,
          onHideSearchDialog: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isSearchDialogVisible = false))
        }, null, 8, ["search-index", "is-loading-courses", "onAddCourse"])
      ]),
      _createVNode(_component_f_button, {
        class: "fixed bottom-20 right-5 w-12 h-12 z-20 flex justify-center items-center md:hidden",
        type: "primary",
        size: "small",
        shape: "circle",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isSearchDialogVisible = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_badge, {
            visible: !_ctx.selectedCoursesIds.size,
            "offset-x": "0.5",
            "offset-y": "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_f_icon, {
                name: "search",
                size: "24"
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ]),
        _: 1
      })
    ])
  ]))
}